import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if @enableClicking}}\n  <a href=\"#\" {{fn this.acceptForDrop}}>\n    {{yield}}\n  </a>\n{{else}}\n  {{yield}}\n{{/if}}\n")